<template>
  <div :class="classnames">
    <interactive-svg-icon>
      <svg-icon-close />
    </interactive-svg-icon>
  </div>
</template>

<script>
  import InteractiveSvgIcon from '@/components/InteractiveSvgIcon'
  import SvgIconClose from '@/svgs/SvgIconClose'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'modal-close-button'

  export default {
    name: 'ModalCloseButton',
    components: {
      'interactive-svg-icon': InteractiveSvgIcon,
      'svg-icon-close': SvgIconClose
    },
    mixins: [ bem ],
    props: {
      isOpen: {
        type: Boolean
      }
    },
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Modal/ModalCloseButton.vue